module.exports = __webpack_public_path__ + "static/media/bubble-2-tablet.7d724e61.svg";